'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Log error to monitoring service (e.g., Sentry)
        console.error('Application error:', error)
    }, [error])

    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
            <div className="w-full max-w-md text-center space-y-6">
                <div className="space-y-2">
                    <h2 className="text-3xl font-bold tracking-tight">Something went wrong!</h2>
                    <p className="text-muted-foreground">
                        We apologize for the inconvenience. An error occurred while processing your
                        request.
                    </p>
                </div>

                {process.env.NODE_ENV === 'development' && error.message && (
                    <div className="rounded-lg bg-destructive/10 p-4 text-left">
                        <p className="text-sm font-mono text-destructive">{error.message}</p>
                    </div>
                )}

                <div className="flex gap-4 justify-center">
                    <Button onClick={() => reset()}>Try again</Button>
                    <Button variant="outline" onClick={() => (window.location.href = '/dashboard')}>
                        Go to Dashboard
                    </Button>
                </div>
            </div>
        </div>
    )
}
